module.exports = __webpack_public_path__ + "resources/icon-44-ban.38afa859d0f44801.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/manage-dialog/img/icon-44-ban.png
// module id = 626
// module chunks = 0 1 2 3